import dayjs, { Dayjs } from 'dayjs';

export const converToDayjs = (str: string) => {
  if (!str) return dayjs();
  const date = dayjs(str);
  if (date.isValid()) return date;
  else return dayjs();
};

export const formatToString = (day: Dayjs) => {
  return day.format('MM/DD/YYYY');
};

export const renderAge = (str: string) => {
  const day = dayjs(str);
  const birthdate = day.toDate();
  const today = new Date();
  let age = today.getFullYear() - birthdate.getFullYear();
  const m = today.getMonth() - birthdate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthdate.getDate())) {
    age--;
  }
  return age.toString();
};
